<section>
    <p-confirmDialog [baseZIndex]="10000" key="positionDialog" [position]="dialogPosition" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Admin</li>
            <li class="breadcrumb-item active">User Role Default Features</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><i class="fas fa-search mr-1"></i> User Role Default Features</span>
                        <button *ngIf="sharedService.checkPermission('Admin_Add')" style="height: 30px !important;width: auto!important;
                        margin-top: -2px;border-color: white;" pButton  type="button" icon="pi pi-plus" label="Add"
                            class="p-button-sm p-button-success float-right" (click)="add()"></button>
                        &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section>
    <p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" key="positionDialog" [position]="dialogPosition" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-1"></div>
            <div class="col-sm-10 p-0">
                <div class="card">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header"><i class="fas fa-chalkboard-teacher mr-1"></i> User Role Default Features</span>
                    </div>
                </div>
            </div>
            <div class="col-sm-1"></div>
        </div>
    </div>
</section> -->


<section>
    <div class="row">
        <!-- <div class="col-md-1"></div> -->
        <div class="col-md-12">
            <div class="card">
                <div class="devcare-card-body">
                 
                  <!-- <div class="row">
                      <div class="col-md-12">
                          <button [ngClass] = "showTopFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="pi pi-filter" (click)="bindShowTopFilter()"
                           style="float: right;height: 30px;" label="Show Filter"></button>
                      </div>
                  </div> -->
     
                  <div class="row">
                      <div class="col-md-4">
                          <button [ngClass] = "showSorting === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'" pButton type="button" icon="pi pi-fw pi-sort-alt" (click)="bindShowSorting()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                          <button [ngClass] = "showFilters === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="fas fa-filter" (click)="bindShowFilter()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                          <button [ngClass] = "showToggle === true ? 'p-button-raised m-2' : 'p-button-outlined m-2'"  pButton type="button" icon="pi pi-list" (click)="bindShowToggle()"
                          [loading]="isSearchLoading" style="float: left;height: 30px;"></button>

                      </div>
                      <div class="col-md-8">

                          <button pButton label="Export" class="p-button-raised  m-2" icon="pi pi-file-excel" type="button" style="float: right;height: 30px;" *ngIf="sharedService.checkPermission('Admin_Export')" (click)="exportUserDefaultFeatures()"
                           ></button>
                          
                           <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash" (click)="clearFilter(dt2)" 
                          style="float: right;height: 30px;"></button>

                          <!-- <button class="p-button-raised m-2" label ="Apply" pButton type="button" icon="pi pi-filter" (click)="applyFilter()"
                          [loading]="isSearchLoading" style="float: right;height: 30px;"></button> -->
                         

                      </div>
                  </div>
                </div>
            </div>
        </div>
        <!-- <div class="col-md-1"></div> -->
    </div>
</section>

<section>
    <div class="card p-p-2" *ngIf="isAdd">
        <div class="row">
            <div class="col-md-9">
                <form [formGroup]="searchForm">
                    <div class="p-fluid p-formgrid p-grid">
        
                        <div class="p-field p-col-12 p-md-6">
                            <label for="userRole">User Role</label>
                            <p-dropdown id="selectedRole" formControlName="roleId" [options]="userRole"  optionLabel="name" optionValue="id" (onChange)="userRoleOnChange($event.value)"></p-dropdown>
                        </div>
        
                        <div class="p-field p-col-12 p-md-6"  [hidden]="!isAdd">
                            <label for="userFeature">User Feature</label>
                            <p-dropdown id="selectedFeature" emptyMessage ="No New Features To Add" formControlName="featureId" [options]="userFeature"  optionLabel="featureName" optionValue="featureId"></p-dropdown>
                        </div>  
                    </div>
                </form>
                </div>
                <div class="col-md-3 " *ngIf="isAdd">
                    <div class="p-d-flex p-jc-between p-mt-4">
                        <button pButton label="Save" class="p-button-raised" icon="pi pi-check" type="button" style="float: right;height: 30px;" [disabled]="!this.searchForm.valid" (click)="save(searchForm)"></button>
                        <button pButton label="Cancel" class="p-button-raised p-button-danger" icon="pi pi-times" type="button" style="float: right;height: 30px;" (click)="cancel()"></button>
                    </div> 
                </div>
        </div>  
      </div>
</section>

<section>
  <div class="row">
      <!-- <div class="col-md-1"></div> -->
      <div class="col-md-12">
          <div class="card">            
              <div class="devcare-table-card-header" *ngIf="showToggle">
                <div class="row">
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-6">
                    <p-multiSelect *ngIf="showToggle" [options]="allColumns" [(ngModel)]="selectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected" optionLabel="header" [showHeader] = "false" [showClear]="false" (onChange)="showAndHideColumn($event)" style="float: right;">
                        <ng-template let-column pTemplate="item">
                            <div class="column-item">
                                <div>{{column.header}}</div>
                            </div>
                        </ng-template>
                    </p-multiSelect>
                    </div>
                </div>
            </div>
              <div class="card-body devcare-table-card-body" style="overflow: hidden;">
                  <p-table #dt2 [value]="applicationFeaturesList" paginatorDropdownAppendTo="body" dataKey="id" [rows]="10" 
                  [lazy] = "true" (onLazyLoad)="loadApplicationFeaturesList($event)"
                  [showCurrentPageReport]="true" [resizableColumns]="true" columnResizeMode="expand"
                  [rowsPerPageOptions]="[10,25,50]" [loading]="loading" styleClass="p-datatable-gridlines" 
                  [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                  currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                  [globalFilterFields]="['featureName','roleName', 'isActive', 'createdBy' , 'createdOn']">
                      <!-- <ng-template pTemplate="colgroup" let-columns>
                        <colgroup>
                            <col>
                            <col>
                            <col>
                            <col>
                            <col>
                            <col>
                        </colgroup>
                     </ng-template> -->
                      <ng-template pTemplate="header">
                          <tr>
                            <!-- <th pResizableColumn style="width: 5rem" *ngIf="isShowColumns('action')">Action</th> -->
                              <th pResizableColumn style="width: 12rem" *ngIf="isShowColumns('featureName')">Feature Name  <span pSortableColumn="featureName" *ngIf="showSorting"><p-sortIcon field="featureName"></p-sortIcon></span>
                                  <p-columnFilter [hidden]="!showFilters" type="text" field="featureName" display="menu" #filterFeatureName [showAddButton]="false" [showOperator]="false"  
                                  [matchModeOptions]="matchModeOptions"  [showClearButton]="false" [showApplyButton]="false">
                                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <input #featureName type="text" value="{{filters?.featureName[0]?.value}}" pInputText class="pinputHeight">
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(featureName.value);applyFilterNew(dt2);filterFeatureName.hide()">Apply</p-button>
                                    </div>
                                </ng-template>
                                  </p-columnFilter>
                              </th>
                              <th pResizableColumn style="width: 12rem" *ngIf="isShowColumns('roleName')">Role Name <span pSortableColumn="roleName" *ngIf="showSorting"><p-sortIcon field="roleName"></p-sortIcon></span>
                                  <p-columnFilter [hidden]="!showFilters" type="text" field="roleName" display="menu" #filterRoleName [showAddButton]="false" [showOperator]="false"  
                                  [matchModeOptions]="matchModeOptions" [showClearButton]="false" [showApplyButton]="false">
                                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <input #roleName type="text" value="{{filters?.roleName[0]?.value}}" pInputText class="pinputHeight">
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(roleName.value);applyFilterNew(dt2);filterRoleName.hide()">Apply</p-button>
                                    </div>
                                  </ng-template>
                                  </p-columnFilter>
                              </th>
                              <th pResizableColumn style="width: 8rem" *ngIf="isShowColumns('isActive')">Is Active  <span pSortableColumn="isActive" *ngIf="showSorting"><p-sortIcon field="isActive"></p-sortIcon></span>
                                  <p-columnFilter [hidden]="!showFilters" type="text" display="menu" field="isActive" #filterIsActive [showAddButton]="false" 
                                  [showMatchModes]="false" [showOperator]="false" [showClearButton]="false" [showApplyButton]="false">
                                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <!--<input #isActive type="text" value="{{filters?.isActive[0]?.value}}" pInputText class="pinputHeight">-->
                                    <p-dropdown #isActive [options]="statusValues" [(ngModel)] ="selectedStatusId" (onChange)="getStatusOnChange($event)"></p-dropdown>
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(isActive.value);applyFilterNew(dt2);filterIsActive.hide()">Apply</p-button>
                                    </div>
                                  </ng-template>
                                  </p-columnFilter>
                              </th>
                              <th pResizableColumn style="width: 12rem" *ngIf="isShowColumns('createdBy')">Created By <span pSortableColumn="createdBy" *ngIf="showSorting"><p-sortIcon field="createdBy"></p-sortIcon></span>
                                  <p-columnFilter [hidden]="!showFilters" type="text" field="createdBy" display="menu" #filterCreatedBy [showAddButton]="false" [showOperator]="false"  
                                  [matchModeOptions]="matchModeOptions" [showClearButton]="false" [showApplyButton]="false">
                                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <input #createdBy type="text" value="{{filters?.createdBy[0]?.value}}" pInputText class="pinputHeight">
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(createdBy.value);applyFilterNew(dt2);filterCreatedBy.hide()">Apply</p-button>
                                    </div>
                                  </ng-template>
                                  </p-columnFilter>
                              </th>
                              <th pResizableColumn style="width: 12rem" *ngIf="isShowColumns('createdOn')">Created On <span pSortableColumn="createdOn" *ngIf="showSorting"><p-sortIcon field="createdOn"></p-sortIcon></span>
                                  <p-columnFilter [hidden]="!showFilters" type="date" field="createdOn" display="menu" #filterCreatedOn [showAddButton]="showAddRuleButton" [showOperator]="false"  
                                  [matchModeOptions]="matchModeOptionsForDate" [showClearButton]="false" [showApplyButton]="false">
                                  <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-calendar #createdOn inputId="navigators" [monthNavigator]="true" [yearNavigator]="true"  yearRange="2000:2030" [ngModel]="value"></p-calendar>
                                   
                                    <div class="p-d-flex p-jc-between p-ai-center p-mt-1">
                                        <p-button pRipple styleClass="btn-height p-mt-2 p-p-2 bg-danger" (onClick)="filter(undefined);applyFilterNew(dt2)">Clear</p-button>
                                        <p-button pRipple  styleClass="btn-height p-mt-2 p-p-2 bg-success" (onClick)="filter(createdOn.value);applyFilterNew(dt2);filterCreatedOn.hide()">Apply</p-button>
                                    </div>
                                  </ng-template>
                                  </p-columnFilter>
                              </th>
                          </tr>
                          <tr [hidden]="!showFilters">
                            <!-- <th *ngIf="isShowColumns('action')"></th> -->
                            <th *ngIf="isShowColumns('featureName')">{{filters?.featureName[0]?.value}}</th>
                            <th *ngIf="isShowColumns('roleName')">{{filters?.roleName[0]?.value}}</th>
                            <!--<th *ngIf="isShowColumns('isActive')">{{filters?.isActive[0]?.value}}</th>-->
                            <th *ngIf="isShowColumns('isActive')">{{selectedStatus}}</th>
                            <th *ngIf="isShowColumns('createdBy')">{{filters?.createdBy[0]?.value}}</th>
                            <th *ngIf="isShowColumns('createdOn')">{{filters?.createdOn[0]?.value| date:'MM/dd/yyyy'}} <span *ngIf="filters?.createdOn.length > 1">-</span> {{filters?.createdOn[1]?.value | date:'MM/dd/yyyy'}}</th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-applicationFeaturesList>
                          <tr>
                            <!-- <td *ngIf="isShowColumns('action')"> <a [routerLink]="" class="table-icon table-icon-menu"><i class="pi pi-ellipsis-v"
                                        (click)="selectedGridMenuItem = applicationFeaturesList; menu.toggle($event)"></i></a>
                                <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
                            </td> -->
                              <td *ngIf="isShowColumns('featureName')"><span class="table-col-countryName">{{applicationFeaturesList.featureName}}</span></td>
                              <td *ngIf="isShowColumns('roleName')"><span>{{applicationFeaturesList.roleName}}</span></td>
                              <td style="width: 8rem" *ngIf="isShowColumns('isActive')"><span class="customer-badge status-active" *ngIf="applicationFeaturesList.isActive">Active</span>
                                  <span class="customer-badge status-inactive" *ngIf="!applicationFeaturesList.isActive">Inactive</span>
                              </td> 
                              <td *ngIf="isShowColumns('createdBy')"><span>{{applicationFeaturesList?.createdByUser?.firstName}}</span></td>
                              <td *ngIf="isShowColumns('createdOn')"><span>{{applicationFeaturesList.createdOn | date:'MM/dd/yyyy'}}</span></td>
                          </tr> 
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                          <tr>
                              <td colspan="5">No Role Features found.</td>
                          </tr>
                      </ng-template>
                  </p-table>
              </div>
          </div>
          <br>
          <br>
          <br>
          <br>
      </div>
      <!-- <div class="col-md-1"></div> -->
  </div>
  <p-toast position="bottom-center"></p-toast>
</section>
